import { Button, InputPicker, Input, Popover, Whisper } from "rsuite";
import styles from "./OtherChargesBlock.module.css";
import { useOtherChargesBlock } from "./useOtherChargesBlock";

function OtherChargesBlock({
  readonly,
  formMode,
  invoiceOtherOld,
  otherChargesArr,
  currency,
}) {
  const { addOther, deleteOther, itemHandler } = useOtherChargesBlock();

  // if (invoiceOtherOld) {
  //   otherChargesArr = [...otherChargesArr, ["Other", invoiceOtherOld]];
  // }
  if (!otherChargesArr || otherChargesArr.length == 0)
    otherChargesArr = [["Other", "0.00"]];
  const allowedToDelete = true;
  const addButton = (
    <>
      <Button
        disabled={readonly}
        onClick={() => addOther()}
        appearance="subtle"
        style={{
          width: 25,
          height: 25,
          fontWeight: 800,
          color: "green",
        }}
      >
        ＋
      </Button>
    </>
  );

  // const deleteButton = (
  //   <>
  //     <Button
  //       disabled={readonly}
  //       onClick={() => deleteHandler(e, rowIndex)}
  //       appearance="subtle"
  //       style={{
  //         width: 25,
  //         height: 25,
  //         fontWeight: 500,
  //         color: "red",
  //       }}
  //     >
  //       ✖
  //     </Button>
  //   </>
  // );

  const DeleteIcon = ({ onClick }) => {
    return (
      <>
        <Button
        className={styles.delete_button}
          disabled={readonly}
          onClick={onClick}
          appearance="subtle"
          style={{
            width: 25,
            height: 25,
            fontWeight: 100,
            color: "red",
          }}
        >
          ✖
        </Button>
      </>
    );
  };
  const inputHandler = (e, rowIndex, colIndex) => {
    itemHandler(e, rowIndex, colIndex);
  };

  // const codeHandler = (e, rowIndex, colIndex) => {
  //   accountHandler(e, rowIndex, colIndex);
  // };

  const deleteHandler = (e, rowIndex) => {
    deleteOther(rowIndex);
  };

  const tipAddCharge = <Popover>Add new item</Popover>;

  return (
    <>
      <div key="account_codes" className={styles.container}>
        {/* <div className={styles.other_title}>
          <div>Other charges</div>
        </div> */}
        {otherChargesArr.map((item, rowIndex) => (
          <div className={styles.other_container}>
            <Input
              id={`other-name-${rowIndex}`}
              key={`${rowIndex}`}
              readOnly={readonly}
              onChange={(e) => {
                inputHandler(e, rowIndex, 0);
              }}
              value={item[0]}
              placeholder=""
              style={{ width: "100px", float: "right", textAlign: "end" }}
            />
            <Input
              id={`other-currency-${rowIndex}`}
              key={`${rowIndex}`}
              readOnly={readonly}
              value={currency}
              placeholder=""
              style={{ width: "60px" }}
            />
            <Input
              id={`other-amount-${rowIndex}`}
              key={`${rowIndex}`}
              readOnly={readonly}
              onChange={(e) => {
                inputHandler(e, rowIndex, 1);
              }}
              value={item[1]}
              placeholder=""
              style={{ width: "150px", marginLeft: "10px" }}
            />
            {rowIndex == 0 && (
              <div
                style={{
                  paddingLeft: "25px",
                  height: "25px",
                  width: "25px",
                  marginTop: "7px",
                }}
              >
                <Whisper
                  delay={500}
                  placement="bottomStart"
                  controlId="control-id-hover"
                  trigger="hover"
                  speaker={tipAddCharge}
                >
                  <div className={styles.buttons}>{!readonly && addButton}</div>
                </Whisper>
              </div>
            )}
            {rowIndex > 0 && (
              <div
                style={{
                  paddingLeft: "25px",
                  height: "23px",
                  width: "23px",
                  paddingTop: "7px",
                }}
              >
                {!readonly && (
                  <DeleteIcon
                    onClick={(e) => {
                      deleteHandler(e, rowIndex);
                    }}
                  />
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}

export const DeleteIcon2 = ({ onClick }) => {
  return (
    <>
      <Button
        onClick={onClick}
        appearance="subtle"
        style={{ width: 35, height: 35 }}
      >
        <svg
          // onClick={onDelete}
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M15 5L5 15"
            stroke="#EF4B4B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 5L5 15"
            stroke="#EF4B4B"
            strokeOpacity="0.5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 5L15 15"
            stroke="#EF4B4B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 5L15 15"
            stroke="#EF4B4B"
            strokeOpacity="0.5"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Button>
    </>
  );
};

export default OtherChargesBlock;
